import Colors from "../../assets/Colors";

export const LoadingOverlayStyles = {
    container: {
        position: 'relative',
        width: '100px',
        height: '100px'
    },
    backdrop: {
        zIndex: 999,
        backgroundColor: Colors.loadingOverlayGrey,
        pointerEvents: 'all'
    },
    image: {
        width: '50px',
        height: '50px',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        zindex: 2,
        pointerEvents: 'none'
    },
    circularProgress: {
        position: 'absolute',
        left: 0,
        top: 0,
        zIndex: 1,
        '& .MuiCircularProgress-circle': {
            animationDuration: '5s'
        }
    }
}
